import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
export function RequireAuth({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAuthenticated,
    isAuthLoading
  } = useAuth();
  const location = useLocation();
  if (isAuthLoading) {
    return <div className="min-h-screen bg-background flex items-center justify-center" data-id="element-14">
        <div className="text-center" data-id="element-15">
          <div className="w-8 h-8 border-2 border-violet-blue/30 border-t-violet-blue rounded-full animate-spin mx-auto mb-3" data-id="element-16" />
          <p className="text-sm text-muted-foreground" data-id="element-17">Verifying session...</p>
        </div>
      </div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{
      from: location
    }} replace data-id="element-18" />;
  }
  return <>{children}</>;
}
export function DcSessionBanner() {
  const {
    isDcAuthenticated,
    refreshDcSession
  } = useAuth();
  const [isRefreshing, setIsRefreshing] = React.useState(false);
  if (isDcAuthenticated) return null;
  return <div className="mb-4 rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900" data-id="element-19">
      Document template lists could not be loaded from Document Center. Other options are still
      available.{' '}
      <button type="button" className="font-medium underline" disabled={isRefreshing} onClick={async () => {
      setIsRefreshing(true);
      try {
        await refreshDcSession();
        window.location.reload();
      } finally {
        setIsRefreshing(false);
      }
    }} data-id="element-20">
        {isRefreshing ? 'Connecting...' : 'Retry Document Center connection'}
      </button>
    </div>;
}